import React from "react";
import MateriaisPopover from "../../../../detail/components/MateriaisPopover";
import AreaTipoDivergenciaEnum from "../../../AreaTipoDivergenciaEnum";
import FinalStepTemplate, {
  useBuildDefaultInfoComponent,
} from "../../../template/FinalStepTemplate";
import useBuildSubmitHandler from "../../../template/UseBuildSubmitHandler";
import { transforSelectItemToDivergenciaInfo } from "../../../template/utils";
import TipoDivergenciasKey from "../../../TipoDivergenciasKey";
import { TipoDivergenciaComponent } from "../../../TiposDeDivergencias";
import MaterialNaoLocalizadoAviamentoObservacaoStep from "./MaterialNaoLocalizadoAviamentoObservacaoStep";
import { AviamentoProps } from "./MaterialNaoLocalizadoAviamentoObservacaoStep";
import LabelValueWithSubtitle from "../../../components/LabelValueWithSubtitle";
import TipoDivergenciasInfoKey from "../../../TipoDivergenciasInfoKey.";

const MaterialNaoLocalizadoAviamentoFinalStep: TipoDivergenciaComponent<
  AviamentoProps
> = ({ onSetStep, onBack, payload }) => {
  const onBackHandler = () => {
    onBack({
      component:
        MaterialNaoLocalizadoAviamentoObservacaoStep as TipoDivergenciaComponent,
    });
  };
  const infoComponents = [
    ...useBuildDefaultInfoComponent(
      AreaTipoDivergenciaEnum.PLANEJAMENTO_DEMANDA,
      TipoDivergenciasKey.MATERIAL_NAO_LOCALIZADO_AVIAMENTO
    ),
    <MateriaisPopover
      materiais={payload.materiais.map(transforSelectItemToDivergenciaInfo)}
    ></MateriaisPopover>,
    <LabelValueWithSubtitle
      label="Descrição do problema"
      value={`${payload.problemDescription}`}
      subtitle={""}
    />,
  ];

  const key = TipoDivergenciasKey.MATERIAL_NAO_LOCALIZADO_AVIAMENTO;
  const { loadingSave, loadingTipoDivergencia, handleSubmit } =
    useBuildSubmitHandler(key, onSetStep);

  return (
    <FinalStepTemplate
      loading={loadingSave || loadingTipoDivergencia}
      onBack={onBackHandler}
      onSetStep={(step) => {
        handleSubmit(step, [
          ...payload.materiais.map((item) => {
            return {
              tipo: item.tipo,
              value: item.id.toString(),
              material: item.material
            };
          }),
          {
            tipo: TipoDivergenciasInfoKey.AJUSTE_MP,
            value: payload.problemDescription,
          },
        ]);
      }}
      progressValue={90}
      stepNumber={"4"}
      infoComponents={infoComponents}
    />
  );
};

export default MaterialNaoLocalizadoAviamentoFinalStep;
